<template>
  <div>
    <div class="padding-container-sm">
      <div class="row mb-4 justify-content-between">
        <div class="col-7">
          <b-input-group size="md">
            <b-input-group-text slot="append" class="bg-white">
              <strong><i class="icon ion-md-search"/></strong>
            </b-input-group-text>
            <b-form-input
              class="border-right-0"
              :value="filter.searchValue"
              placeholder="Search for patient name or ID in Patient list"
              @keyup.enter.native="onSearchText"
              @blur.native="onSearchText"
            />
          </b-input-group>
        </div>
      </div>
      <v-table
        :options="
          permissions.followup && permissions.followup.create
            ? tablePropsToResponder
            : tablePropsToNavigator
        "
        :total-count="Number(totalCount)"
        :data="followUpList"
      >
        <template slot="patientName" slot-scope="slotProps">
          <div class="align-items-center d-flex patient-name-content">
            <img
              :src="
                require(`@/assets/image/${
                  slotProps.data.datum.gender === 'male' ? 'boy' : 'girl'
                }.svg`)
              "
              width="35"
              height="35"
              :alt="slotProps.data.datum.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.first_name"
            />
            <div
              class="d-flex flex-column justify-content-center"
              v-if="slotProps"
            >
              <span class="text-center pl-2">
                {{ slotProps.data.datum.first_name | capitalizefirst }}
                {{ slotProps.data.datum.last_name | capitalizefirst }}
              </span>
              <span v-if="permissions.patientmessage && permissions.patientmessage.view" class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                Send Message
              </span>
            </div>
          </div>
        </template>
        <template slot="userContact" slot-scope="slotProps">
          <div>
            {{
              slotProps.data &&
                slotProps.data.datum.mobile_no
                  | mobileformat(
                    slotProps.data && slotProps.data.datum.country_code
                  )
            }}
          </div>
          <div>
            {{ slotProps.data && slotProps.data.datum.email }}
          </div>
        </template>
        <template
          slot="symptoms"
          slot-scope="slotProps"
          v-if="
            (permissions.followup && permissions.followup.create) ||
              permissions.alert.view
          "
        >
          <div
            class="d-flex flex-row justify-content-around alertCell"
            v-for="symptom in slotProps.data.datum.symptoms"
            :key="symptom.id"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center w-50 p-2 col"
              :class="{'col-8': permissions.followup && permissions.followup.create}"
            >
              <span class="unassigned w-100 text-break">
                <b>
                  <div> <span class="text-dark">
                     {{symptom.symptoms && symptom.symptoms.length !== 0 ? 'Symptoms : ' : ''}}
                  </span> {{ symptom.symptoms }}</div>
                  <span class="text-dark">
                     {{symptom.description ? 'Notes : ' : ''}}
                  </span>
                  {{
                    symptom.description ? `${symptom.description}.` : ''
                  }}
                </b>
              </span>
              <span class="align-items-center d-flex py-1">
                <img
                  v-if="symptom.is_after_hour"
                  src="@/assets/image/clock.svg"
                  width="15"
                  height="15"
                  alt=""
                  class="mr-1"
                />
                {{
                  dateFormate(getFormattedDate(symptom.created_at, dateTime))
                }}
              </span>
            </div>
            <div
              v-if="permissions.followup && permissions.followup.create"
              class="d-flex flex-column justify-content-center align-items-center w-50 p-2 col col-4"
            >
              <span class="d-flex justify-content-around">
                <button
                  class="btn-modify"
                  @click="
                    editSymptoms(slotProps.data.datum.patient_id, symptom)
                  "
                >
                  <i class="icon ion-md-create" />Modify
                </button>
                <button
                  class="btn-delete"
                  @click="deleteFollowUp(slotProps.data.index, symptom.id)"
                >
                  <i class="icon ion-md-close" />Delete
                </button>
              </span>
            </div>
          </div>
        </template>
        <template
          slot="symptoms-action-header"
          v-if="
            (permissions.followup && permissions.followup.create) ||
              permissions.alert.view
          "
        >
          <div class="d-flex flex-row justify-content-around">
            <div class="col-8">
              Symptoms
            </div>
            <div v-if="permissions.followup && permissions.followup.create" class="col-4">
              Controls
            </div>
          </div>
        </template>
        <template
          v-if="permissions.alert.edit"
          slot="status"
          slot-scope="slotProps"
        >
          <div
            v-if="slotProps"
            class="d-flex flex-column justify-content-between align-items-center"
          >
            <span
              :class="slotProps.data.datum.status ? 'resolved' : 'unresolved'"
            >
              <div
                v-if="slotProps.data.datum.status"
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <span
                  v-if="slotProps.data.datum && slotProps.data.datum.status"
                  @click="viewResolvedNotes(slotProps.data.datum)"
                  class="btn btn-link px-0"
                >
                  view note
                </span>
              </div>
            </span>
          </div>
        </template>
        <template
          v-if="permissions.alert.edit"
          slot="actions"
          slot-scope="slotProps"
        >
          <div
            v-if="slotProps.data.datum"
            class="d-flex justify-content-around"
          />
          <div v-if="slotProps.data.datum && !slotProps.data.datum.status">
            <button
              class="btn btn-sm btn-primary"
              @click="onResolve(slotProps.data.datum)"
            >
              Resolve
            </button>
            <div  v-if="slotProps.data.datum.resolved_alert_id" class="py-1 text-danger">(Pending)</div>
          </div>
        </template>
      </v-table>
    </div>
    <b-modal
      id="modal-center"
      ref="editSymptomsRef"
      body-class="pt-0"
      @hide="hideModal"
      centered
      title="Edit Symptoms"
    >
      <div class="row px-4 mt-4">
        <div class="col-12 px-0 form-group">
          <b-form-group label-for="notes" label="Notes">
              <textarea
                maxlength="250"
                class="form-control"
                name="description"
                v-model="formData.description"
              />
          </b-form-group>
        </div>
        <div>
          <b-form-group label="Symptoms" label-for="symptoms-picker">
            <span
              class="error-text text-left"
              v-if="
                !isEmpty(selectedAsssessments) &&
                  isSubmitted &&
                  !formData.description
              "
              >Select atleast one field</span
            >
          </b-form-group>
        </div>
        <v-multi-select-table
          :selectedSymptoms="followUpSymptoms"
          :actionType="`Edit`"
          @selectedItems="getSelectedSymptoms"
          ref="symptomsSelectorTable"
        >
        </v-multi-select-table>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="onValidateAndSubmit"
        >
          Update
        </b-btn>
        <b-btn
          size="sm"
          variant="outline-primary"
          class="float-right btn btn-outline-primary  mr-2"
          @click="hideModal"
        >
          Cancel
        </b-btn>
      </div>
    </b-modal>
    <v-resolution ref="resolution" :onFollowUp="fetchFollowUpList"/>
    <v-loader :isLoading="isLoading || isProtocolLoading || isResolutionLoading" />

  </div>
</template>

<script>
import VTable from "@/components/table/index.vue";
import { mapGetters } from "vuex";
import VLoader from "@/components/loader/index.vue";
import VMultiSelectTable from "@/components/table/MultiSelect/index.vue";
import constants from "@/constants/app.properties";
import VResolution from "@/components/resolution/Resolution.vue";
import dateFormate from "@/mixins/dateFormate";

const followUpData = {
  id: "",
  description: "",
  symptoms: [],
  symptoms_text: [],
  patient_id: ""
};

export default {
  name: "followUpList",
  components: {
    VTable,
    VLoader,
    VMultiSelectTable,
    VResolution
  },
  mixins: [dateFormate],
  data() {
    return {
      patient: {},
      formData: {},
      selectedAsssessments: [],
      isSubmitted: false,
      followUpDetails: [],
      filter: {
        status: this.status,
        searchValue: "",
        limit: 10,
        pageNo: 1,
        filterType: this.status.toLowerCase()
      },
      statusProps: {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            cellSlot: {
              name: "status"
            },
            dataKey: "email",
            dataType: String,
            label: "Status"
          },
      actionProps: {
        headerCellProps: {
          class: "header-cell"
        },
        cellProps: {},
        cellSlot: {
          name: "actions"
        },
        disablePadding: false,
        label: "Actions"
      },
      tablePropsToResponder: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-left"
            },
            cellSlot: {
              name: "patientName"
            },
            dataKey: "name",
            dataType: String,
            label: "Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "mr_id",
            dataType: String,
            label: "ID"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellSlot: {
              name: "userContact"
            },
            cellProps: {},
            dataKey: "user",
            dataType: String,
            label: "Contact"
          },
          {
            headerCellProps: {
              class: "header-cell",
              colspan: 2
            },
            headerCellSlot: {
              name: "symptoms-action-header"
            },
            cellSlot: {
              name: "symptoms"
            },
            cellProps: {
              colspan: 2,
              class: "alertCol"
            },
            dataKey: "symptoms",
            dataType: String,
            label: "Alert Triggered"
          }
        ],
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: "FolowUpList"
      },
      tablePropsToNavigator: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {
              class: "text-left"
            },
            cellSlot: {
              name: "patientName"
            },
            dataKey: "name",
            dataType: String,
            label: "Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellProps: {},
            dataKey: "mr_id",
            dataType: String,
            label: "ID"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellSlot: {
              name: "userContact"
            },
            cellProps: {},
            dataKey: "user",
            dataType: String,
            label: "Contact"
          },
          {
            headerCellProps: {
              class: "header-cell",
              colspan: 2
            },
            headerCellSlot: {
              name: "symptoms-action-header"
            },
            cellSlot: {
              name: "symptoms"
            },
            cellProps: {
              colspan: 2,
              class: "alertCol"
            },
            dataKey: "symptoms",
            dataType: String,
            label: "Alert Triggered"
          }
        ],
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: "FolowUpList"
      }
    };
  },
  computed: {
    ...mapGetters({
      followUpList: "followUps/getFollowUpList",
      followUpSymptoms: "followUps/getFollowUpSymptoms",
      assessmentSymptoms: "assessments/getAssessmentSymptoms",
      isLoading: "followUps/getLoading",
      totalCount: "followUps/getTotalCount",
      permissions: "auth/getModulePermissions",
      currentUser: "auth/getUser",
      isProtocolLoading: "managementProtocolTemplate/getLoading",
      isResolutionLoading: "followUps/getIsResolutionLoading",
       managementProtocolTemplate:
        "managementProtocolTemplate/getManagementProtocolTemplate"
    })
  },
    props: {
    status: {
      type: String,
      required: true,
      default: 'UnResolved'
    }
  },
  watch: {
    followUpSymptoms: {
      handler: "fetchFollowUpSymptoms"
    },
    currentUser: {
      immediate: true,
      handler: "onCurrentUserChange"
    },
    managementProtocolTemplate: {
      handler: "fetchProtocolTemplate"
    }
  },
  beforeMount() {
    this.$store.dispatch("followUps/fetchFollowUps", this.filter);
    if (this.status == 'UnResolved') {
      this.tablePropsToNavigator.columns.push(this.actionProps);
    } else {
      this.tablePropsToNavigator.columns.push(this.statusProps);
    }
  },
  mounted() {
    this.$store.dispatch("resolve/getResolveActions");
  },
  methods: {
    fetchFollowUpSymptoms(value) {
      if (value.length !== 0) {
        this.$refs.editSymptomsRef.show();
      }
    },
    onPageChange(pageNo, rowsPerPage) {
      this.permissions.followup.create
        ? (this.tablePropsToResponder.page = pageNo)
        : (this.tablePropsToNavigator.page = pageNo);
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
      this.fetchFollowUpList();
    },
    onSearchText(event) {
      this.filter = {
        ...this.filter,
        pageNo: "1",
        searchValue: event.target.value
      };
      this.fetchFollowUpList();
    },
    fetchFollowUpList() {
      this.$store.dispatch("followUps/fetchFollowUps", this.filter);
    },
    editSymptoms(patientId, symptom) {
      this.$store.dispatch("assessments/getAssessmentSymptoms");
      this.$store.dispatch("followUps/getFollowUpSymptoms", symptom.id);
      this.formData = { ...followUpData };
      this.formData.patient_id = patientId;
      this.formData.description = symptom.description;
      this.formData.id = symptom.id;
      this.isSubmitted = false;
      if (!symptom.symptoms) {
        this.$refs.editSymptomsRef.show();
      }
    },

    onValidateAndSubmit() {
      this.isSubmitted = true;
      if (
        (this.selectedAsssessments && this.selectedAsssessments.length !== 0) ||
        (this.formData.description && this.formData.description.trim() !== "")
      ) {
        this.formData.symptoms =
          this.selectedAsssessments &&
          this.selectedAsssessments.map(symptom => {
            return symptom.id;
          });
        this.formData.symptoms_text =
          this.selectedAsssessments &&
          this.selectedAsssessments.map(symptom => {
            return symptom.name;
          });
        this.$store.dispatch("followUps/update", {
          filter: this.filter,
          data: this.formData
        });
        this.$refs.editSymptomsRef.hide();
      }
    },
    hideModal() {
      this.$refs.editSymptomsRef.hide();
      this.formData = { ...followUpData };
      this.selectedAsssessments = [];
    },
    getSelectedSymptoms(items) {
      this.selectedAsssessments = items;
    },
    addPatient() {
      this.$router.push({
        name: "patient.create"
      });
    },
    deleteFollowUp(index, id) {
      const data = this.filter;
      const content = {
        title: "Delete Follow up",
        message: "Do you want to delete this follow up?"
      };
      this.conFirmAlert(
        content,
        () => {
          this.$store.dispatch("followUps/remove", { data, id });
        },
        () => {}
      );
    },
    onResolve(data) {
      this.followUpDetails = data.symptoms;
      if (data.resolved_alert_id) {
        this.$refs.resolution.showResolutionToFollowUp(this.followUpDetails, {}, 'edit');
        this.getUpdatedResolutionData(data, false);
      } else {
        this.$store.dispatch('managementProtocolTemplate/getProtocolList', true);
      }
    },
    fetchProtocolTemplate(value) {
      if (value) {
        this.$refs.resolution.showResolutionToFollowUp(this.followUpDetails, value, 'add');
      }
    },
    getUpdatedResolutionData(patientDetails, isGetProtocol) {
      const { created_at } = patientDetails.symptoms[0];
      const followUpDate = this.getFormattedDate(
        created_at,
        constants.DATE_FORMAT
      );
      const data = {
        patientId: patientDetails.patient_id,
        followUpDate,
        resolvedId: patientDetails.resolved_alert_id
      }
      this.$store.dispatch("followUps/getResolvedNotes", data);
      this.$store.dispatch('managementProtocolTemplate/getProtocolList', isGetProtocol);
    },
    viewResolvedNotes(patientDetails) {
      this.$refs.resolution.showResolvedNotesToFollowUp(patientDetails);
      this.getUpdatedResolutionData(patientDetails, false);
    },
    onCurrentUserChange() {
      if (this.currentUser.designation === "CARE_NAVIGATOR") {
          this.filter = {
          ...this.filter,
          filterType: this.status.toLowerCase(),
          };
      } else {
          this.filter = {
          ...this.filter,
          filterType: "unresolved",
        }
      }
    },
    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../alerts/style.scss";
</style>
